import React from 'react';

import C from '../../constants';
import store from 'store';
import rStore from '../../store';
import PolyUtil from "../../util/PolyUtil";
import {displayModal} from "./display";
import {SubmissionError} from "redux-form";
import TransUnionExam from "../../components/credit/TransUnionExam";
import tu_exam from '../../util/test_data/tu_exam.json';
import tu_exam_pass from '../../util/test_data/tu_exam_pass.json';
import tu_exam_more from '../../util/test_data/tu_exam_more.json';
import {fetchTenantIdmaStatus} from "../../containers/tenant/actions/tenant";
import {fetchGuarantorIdmaStatus} from "../../containers/guarantor/actions/guarantor";
import Alert from 'react-s-alert';

export const setCreditExam = (exam) => ({
    type: C.SET_CREDIT_EXAM,
    payload: exam
});

export const handleInitiateCredit = (data, tenantId, key) => dispatch => {
    const creditData = Object.assign({}, data, {
        SocialSecurityNumber: data.SocialSecurityNumber.replace(new RegExp('-', 'g'), ''),
        IncomeFrequency: 'Annual',
        HomePhoneNumber: PolyUtil.formatPhoneStd(data.HomePhoneNumber).replace('+', ''),
        DateOfBirth: PolyUtil.formatAPIDate(data.DateOfBirth),
    });

    const reqUrl = tenantId ? '/api/credit/idma/initiate/guarantor/' + tenantId + '/' + key + '/'
        : '/api/credit/idma/initiate/tenant/';

    return PolyUtil.fetchWrapper(reqUrl, {
        method: "POST",
        body: JSON.stringify(creditData)
    }).then((data) => {
        return dispatch(setCreditExam(data));
    }).then(() => {
        return dispatch(displayModal({
            id: 'tu_exam_modal',
            header: "TransUnion Verification",
            body: (<TransUnionExam/>),
            tenantId: tenantId,
            key: key,
        }));
    }).catch((error) => {
        if (error.error_code === "transunion_exam_retrieve_error_409") {
            dispatch(setCreditExam({
                Evaluation: 'Manual'
            }));
            return dispatch(displayModal({
                id: 'tu_exam_modal',
                header: "TransUnion Verification Issue",
                body: (<TransUnionExam/>)
            }));
        }
        else if (error.error_code && error.error_code.indexOf("transunion_set_renter_error")  !== -1) {
            const raw_transunion_set_renter_error = error.error_message[0].split("renter.", 2)[1].split(": ", 2);
            const error_field = raw_transunion_set_renter_error[0];
            const error_message = raw_transunion_set_renter_error[1];

            error[error_field] = [error_message];
            error._error_code = error.error_code;
            error._error_message = error.error_message;
            delete error.error_code;
            delete error.error_message;
        }
        else if (error.error_code === "transunion_application_accept_error_409") {
            const raw_transunion_application_accept_error = error.error_message[0].split(": ", 2);
            const error_field = raw_transunion_application_accept_error[0];
            const error_message = raw_transunion_application_accept_error[1];

            error[error_field] = [error_message];
            error._error_code = error.error_code;
            error._error_message = error.error_message;
            delete error.error_code;
            delete error.error_message;
        }
        else {
            Alert.error(error.error_message);
        }
        console.log("Error: ", error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};

export const handleReInitiateCredit = (tenantId, key) => dispatch => {
    const data = rStore.getState().form.credit_form.values;

    const creditData = Object.assign({}, data, {
        SocialSecurityNumber: data.SocialSecurityNumber.replace(new RegExp('-', 'g'), ''),
        IncomeFrequency: 'Annual',
        HomePhoneNumber: PolyUtil.formatPhoneStd(data.HomePhoneNumber).replace('+', ''),
        DateOfBirth: PolyUtil.formatAPIDate(data.DateOfBirth),
    });


    const reqUrl = tenantId ? '/api/credit/idma/initiate/guarantor/' + tenantId + '/' + key + '/'
        : '/api/credit/idma/initiate/tenant/';

    return PolyUtil.fetchWrapper(reqUrl, {
        method: "POST",
        body: JSON.stringify(creditData)
    }).then((data) => {
        return dispatch(setCreditExam(data));
    }).catch((error) => {
        if (error.error_code === "transunion_exam_retrieve_error_409") {
            dispatch(setCreditExam({
                Evaluation: 'Manual'
            }));
            return dispatch(displayModal({
                id: 'tu_exam_modal',
                header: "TransUnion Verification Issue",
                body: (<TransUnionExam/>)
            }));
        }
        else if (error.error_code && error.error_code.indexOf("transunion_set_renter_error") !== -1) {
            const raw_transunion_set_renter_error = error.error_message[0].split("renter.", 2)[1].split(": ", 2);
            const error_field = raw_transunion_set_renter_error[0];
            const error_message = raw_transunion_set_renter_error[1];

            error[error_field] = [error_message];
            error._error_code = error.error_code;
            error._error_message = error.error_message;
            delete error.error_code;
            delete error.error_message;
        }
        else if (error.error_code === "transunion_application_accept_error_409") {
            const raw_transunion_application_accept_error = error.error_message[0].split(": ", 2);
            const error_field = raw_transunion_application_accept_error[0];
            const error_message = raw_transunion_application_accept_error[1];

            error[error_field] = [error_message];
            error._error_code = error.error_code;
            error._error_message = error.error_message;
            delete error.error_code;
            delete error.error_message;
        }
        else {
            Alert.error(error.error_message);
        }
        console.log("Error: ", error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};

export const handleInitiateCreditTest = (data, tenantId, key) => dispatch => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            dispatch(setCreditExam(tu_exam));
            resolve();
        }, 300);
    }).then(() => {
        return dispatch(displayModal({
            id: 'tu_exam_modal',
            header: "TransUnion Verification",
            body: (<TransUnionExam/>)
        }));
    });
};

export const handleSubmitCreditExam = (answers) => dispatch => {
    const exam = Object.assign({}, rStore.getState().credit.exam, {
        Questions: rStore.getState().credit.exam.Questions.map((question) => {
            return {
                ...question,
                SelectedAnswerId: answers[question.Id].SelectedAnswerId
            };
        })
    });

    return PolyUtil.fetchWrapper('/api/credit/idma/submit-exam/', {
        method: "POST",
        body: JSON.stringify(exam)
    }).then((data) => {
        return dispatch(setCreditExam(data));
    }).then(() => {
        if (store.get('type') === 'tenant') {
            return dispatch(fetchTenantIdmaStatus());
        } else {
            const modal = rStore.getState().display.modals.find((i) => i.id === 'tu_exam_modal');
            return dispatch(fetchGuarantorIdmaStatus(modal.tenantId, modal.key));
        }
    }).catch((error) => {
        if (error.error_code === "transunion_exam_submit_error_409") {
            dispatch(setCreditExam({
                Evaluation: 'Manual'
            }));
            return dispatch(displayModal({
                id: 'tu_exam_modal',
                header: "TransUnion Verification Issue",
                body: (<TransUnionExam/>)
            }));
        }
        else {
            Alert.error(error.error_message);
        }
        console.log("Error: ", error);
    });
};

export const handleSubmitCreditExamPass = (answers) => dispatch => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            dispatch(setCreditExam(tu_exam_pass));
            resolve();
        }, 300);
    });
};

export const handleSubmitCreditExamMore = (answers) => dispatch => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            dispatch(setCreditExam(tu_exam_more));
            resolve();
        }, 300);
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/credit.js